export const getLatestList = (listOldData, listIds, listUpdatedData) => {
    let result = listUpdatedData || [];
    result = result.filter(item => listIds.includes(item.id));
    const listUpdatedIds = listUpdatedData.map((item) => item.id);
    for (const item of listOldData) {
        if (!listIds.includes(item.id)) {
            continue;
        }
        if (listUpdatedIds.includes(item.id)) {
            continue;
        }
        result.push(item);
    }
    return result;
};

export const getRequestUrlParams = (object) => {
  let params = "";
  for (const [key, value] of Object.entries(object)) {
    if (value) {
      params += `${key}=${value}&`;
    }
  }
  return params;
};


// WEBPACK FOOTER //
// ./src/utils/data-handling.js